import { ReactNode, useMemo } from 'react';
import { UsersContext, UsersContextValue } from './UsersContext';

type UsersProviderProps = UsersContextValue & {
  children: ReactNode;
};

// Feature-local, not app-level: the Users root mounts this with the props the host passed it, so the
// feature's internal components read useUsers() instead of being handed viewer/account/permissions
// one level at a time. Deliberately not exported from the package entry point.
export default function UsersProvider({
  viewer,
  account,
  userPermissions,
  createRoleInSubAccounts,
  updateRoleInSubAccounts,
  countSubAccounts,
  deleteRoleFromSubAccounts,
  children,
}: UsersProviderProps) {
  const value = useMemo(
    () => ({
      viewer,
      account,
      userPermissions,
      createRoleInSubAccounts,
      updateRoleInSubAccounts,
      countSubAccounts,
      deleteRoleFromSubAccounts,
    }),
    [
      viewer,
      account,
      userPermissions,
      createRoleInSubAccounts,
      updateRoleInSubAccounts,
      countSubAccounts,
      deleteRoleFromSubAccounts,
    ],
  );

  return <UsersContext.Provider value={value}>{children}</UsersContext.Provider>;
}
